import { Card } from "flowbite-react";

const ChartSkeleton = () => (
  <Card className="w-1/2 h-[400px] bg-white dark:bg-gray-800 rounded-lg shadow flex items-center justify-center animate-pulse">
    <div className="w-full h-3/4 flex flex-col gap-4 items-center justify-center">
      <div className="h-8 w-1/3 bg-gray-300 dark:bg-gray-700 rounded mb-4" />
      <div className="h-56 w-full bg-gray-200 dark:bg-gray-800 rounded" />
    </div>
  </Card>
);

export default ChartSkeleton;
